import flow from 'lodash/flow';

import { ReadUserStorageApiResponse } from 'apis/userStorage/types/userStorageApi.types';

import { migrateDetectLanguage } from './001-migrateDetectLanguage';
import { migrateAgentCopilotSummaryLanguage } from './002-migrateAgentCopilotSummaryLanguage';

export function migrateReadUserStorageResponse(
  response: any,
): ReadUserStorageApiResponse {
  return flow(
    // Chain migrations here - usually in order of oldest to newest
    migrateDetectLanguage,
    migrateAgentCopilotSummaryLanguage,
  )(response);
}
